import React from "react";

const Basketball3x3 = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      className={className}
    >
      <path d="M7.63566 6L7.06782 8.80892H8.02143L13.1187 18H16.2204L16.7884 15.1905H15.835L10.7374 6H7.63566ZM19.4075 6.01712L18.8468 8.79244H20.0695L19.7311 10.4104H18.1452L17.5583 13.3669H19.1604L18.7953 15.1739H17.554L16.9862 17.9828H20.3604L22.318 16.2491L22.9042 13.3785L21.862 11.9214L23.4536 10.4342L24 7.76884L22.7469 6.01715L19.4075 6.01712ZM3.63925 6.01712L1.68159 7.75094L1.11994 10.4585L2.16213 11.9157L0.570391 13.4024L0 16.231L1.25303 17.9827H4.59232L5.15285 15.2076H3.93004L4.29361 13.4264H5.87924L6.46611 10.47H4.86366L5.20443 8.82611H6.29054L6.85801 6.01712H3.63925ZM15.5373 6.03424L13.0485 8.60534L14.5992 11.4023L17.1091 8.80888H18.0788L18.6391 6.03427L15.5373 6.03424ZM6.74707 15.1905H5.91299L5.3524 17.9659H8.31887L10.7956 15.3868L9.24436 12.59L6.74707 15.1905Z" />
    </svg>
  );
};

export default Basketball3x3;
